/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-ComboBoxBasicExample{max-width:300px}.ms-ComboBoxBasicExample .ms-ComboBox-container{margin:0 0 10px 0}\n"}]);